<div class="max-w-6xl mx-auto px-6 pb-6">
    <div class="space-y-6">
        <ng-container *ngIf="simplifiedConfig">
            <ng-container *ngFor="let sectionKey of metaDataSettings | keyvalue">
                <div class="bg-white rounded-lg shadow-md overflow-hidden border border-gray-100">
                    <!-- Encabezado con toggle de sección -->
                    <div class="flex items-center justify-between p-4 bg-gray-50 border-b">
                        <h3 class="text-lg font-semibold text-gray-800 capitalize">
                            {{ sectionKey.key | translate }}
                        </h3>
                        <label class="relative inline-flex items-center cursor-pointer">
                            <!-- Input oculto -->
                            <input type="checkbox" [(ngModel)]="
                                    simplifiedConfig[sectionKey.key].visible
                                        .value
                                " [debounce]="0" (onDebounce)="update()" class="sr-only peer" />
                            <!-- Switch toggle -->
                            <div
                                class="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-indigo-600">
                            </div>
                            <span class="ml-3 text-sm font-medium text-gray-600">
                                {{
                                sectionKey.value.visible.label ||
                                "Mostrar sección"
                                }}
                            </span>
                        </label>
                    </div>

                    <!-- Cuerpo de sección: solo si está visible -->
                    <div *ngIf="sectionKey.value.visible.value" class="p-4 space-y-6">
                        <ng-container *ngFor="
                                let field of sectionKey.value.fields | keyvalue
                            ">
                            <div class="space-y-2">
                                <div class="flex justify-between items-center">
                                    <label class="block text-sm font-medium text-gray-700 capitalize">
                                        <span *ngIf="field.value.icon" class="mr-2 text-gray-500">
                                            <i [class]="field.value.icon"></i>
                                        </span>
                                        {{
                                        field.value.label || field.key
                                        | translate
                                        }}
                                    </label>
                                    <!-- Toggle de visibilidad del campo individual -->
                                    <label class="relative inline-flex items-center cursor-pointer">
                                        <input type="checkbox" [(ngModel)]="
                                                simplifiedConfig[sectionKey.key]
                                                    .fields[field.key].visible
                                            " class="sr-only peer" title="Mostrar campo" [debounce]="0"
                                            (onDebounce)="update()" />
                                        <div
                                            class="w-9 h-5 bg-gray-200 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-indigo-300 rounded-full peer peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-4 after:w-4 after:transition-all peer-checked:bg-indigo-600">
                                        </div>
                                    </label>
                                </div>

                                <!-- Campo input dinámico -->
                                <msc-input *ngIf="field?.value?.type !== false" [type]="field?.value?.type" [(ngModel)]="
                                        simplifiedConfig[sectionKey.key].fields[
                                            field.key
                                        ].value
                                    " [placeholder]="field?.value?.placeholder" [debounce]="800"
                                    (onDebounce)="update()"
                                    class="w-full px-3 py-2 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500"></msc-input>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </div>
</div>